import './App.css';
import Home from './pages/Home';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Product from './pages/Product';
import { useState, useEffect } from "react";
import Checkout from './pages/Checkout';
import Dashboard from './pages/dashboard';
import Subdb from './pages/dashboard/Subdb';
import Saldo from './pages/dashboard/Saldo';
import Support from './pages/dashboard/Support';
import Adsmitra from './pages/dashboard/Adsmitra';
import Katalog from './pages/dashboard/Katalog';
import KatalogDetail from './pages/dashboard/KatalogDetail';
import Pricelist from './pages/dashboard/Pricelist';
import Resi from './pages/dashboard/Resi';
import Preorder from './pages/dashboard/PreOrder';
import PoDetail from './pages/dashboard/PoDetail';
import PoInvoice from './pages/dashboard/PoInvoice';
import ReadyStok from './pages/dashboard/ReadyStock';
import Info from './pages/dashboard/Info';
import Tutorial from './pages/dashboard/Tutorial';
import Setting from './pages/dashboard/Setting';
import Profile from './pages/dashboard/Profile';
import Rekeningku from './pages/dashboard/Rekeningku';
import ReadyStockKirim from './pages/dashboard/ReadyStockKirim';
import ReadyStockOrdered from './pages/dashboard/ReadyStockOrdered';
import Konfirmasi from './pages/dashboard/Konfirmasi';
import Transaksi from './pages/dashboard/Transaksi';
import Pesan from './pages/dashboard/Pesan';
import Dropship from './pages/dashboard/Dropship';
import PoInvoiceSubdb from './pages/dashboard/PoInvoiceSubdb';
import Blog from './pages/Blog';
import Blogs from './pages/Blogs';
import ReadyStockDummy from './pages/dashboard/ReadyStockDummy';
import ReadyStockFull from './pages/dashboard/ReadyStockFull';
import ReadyStockFlashSale from './pages/dashboard/ReadyStockFlashSale';
import ReadyStock from './pages/dashboard/ReadyStock';

function App() {
  const [cart, setCart] = useState(false);
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home Cart={cart} />} />
        <Route path="/blogs" element={<Blogs Cart={cart} />} />
        <Route path="/blog/:idblog" element={<Blog Cart={cart} />} />
        {/* <Route path="product/:id" element={<Product Cart={cart} UpdatedCart={setCart} />} /> */}
        <Route path="dashboard" element={<Dashboard Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/subdb" element={<Subdb Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/saldo" element={<Saldo Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/support" element={<Support Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/adsmitra" element={<Adsmitra Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/katalog" element={<Katalog Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/katalog/:idkatalog" element={<KatalogDetail Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/pricelist" element={<Pricelist Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/resi" element={<Resi Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/po/list" element={<Preorder Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/po/detail/:idproduk" element={<PoDetail Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/po/invoice/:invoice/:idpoproduk" element={<PoInvoice Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/po/subdb/invoice/:invoice/:idpoproduk/:idmitra" element={<PoInvoiceSubdb Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/readystok" element={<ReadyStock Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/readystok/internal" element={<ReadyStockFlashSale Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/info" element={<Info Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/tutorial" element={<Tutorial Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/setting" element={<Setting Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/profile" element={<Profile Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/rekeningku" element={<Rekeningku Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/readystock/kirim" element={<ReadyStockKirim Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/readystock/detailorder" element={<ReadyStockOrdered Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/konfirmasi" element={<Konfirmasi Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/transaksi" element={<Transaksi Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/pesan" element={<Pesan Cart={cart} UpdatedCart={setCart} />} />
        <Route path="dashboard/po/dropship" element={<Dropship Cart={cart} UpdatedCart={setCart} />} />
      </Routes>
    </Router>
  )
}

export default App;
